export default function NoMatch() {
    return(
        <div>404 not found aaha</div>
    )
}